import {Spin} from 'antd';
import React, {useEffect, useState} from 'react';

function isCalendlyEvent(e) {
  return e.origin === "https://calendly.com" && e.data.event?.startsWith("calendly.");
}

export const Calendly = ({onSuccess}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const Calendly = (window as any).Calendly;
    if (Calendly) {
      Calendly.initInlineWidget({
        url: "https://calendly.com/d/cw2k-kf2-7g3/cuegrowth-round-robin",
        parentElement: document.getElementById("calendly-embed")
      });
      setTimeout(() => setLoading(false), 1000);
    }

    const listener = function (e) {
      if (isCalendlyEvent(e)) {
        if (e.data.event === 'calendly.event_scheduled') {
          onSuccess();
        }
      }
    };
    window.addEventListener('message', listener);

    return () => {
      window.removeEventListener('message', listener);
    };
  }, []);

  return (
    <Spin spinning={loading} tip="Loading..." size="large">
      <div id="calendly-embed" style={{ minWidth: "312px", height: "715px" }} />
    </Spin>
  );
};
